/**
 * Категории событий
 *
 * @name constants.EVENTS
 * @type {Object.<string>}
 */
export const CATEGORIES: { [key: string]: string } = {
    applicationForm: 'application_form',
    changePassword: 'changePassword',
    paidServices: 'paid_services',
    loyaltyProgramLanding: 'loyalty_program_landing',
};

/**
 * Тип действия событий
 *
 * @name constants.ACTIONS
 * @type {object.<string>}
 */
export const ACTIONS: { [key: string]: string } = {
    started: 'started',
    finished: 'finished',
    error: 'error',
    clickConsultation: 'click_get_consultation',
    clickProblem: 'click_problem_solution',
    clickFindPrice: 'click_find_price',
    click: 'click',
};

/**
 * Типы событий
 *
 * @name constants.EVENTS
 * @type {object.<string>}
 */
export const EVENTS: { [key: string]: string } = {
    UAevent: 'UAevent',
};
